import axios from "axios";
import {handleError} from "@/_helpers/utils";

export default {
  namespaced: true,
  state () {
    return {
      loaded: false,
      error: null,
      list: null,
    }
  },
  actions: {
    load (context) {
      if (context.getters.loaded) return Promise.resolve();
      context.commit('set_loaded', false);
      context.commit('set_error', null);
      return axios.get(`/1.0/talentq/dictionary/assessments`)
        .then(response => response.data.data)
        .then(list => {
          context.commit('set_list', list);
          context.commit('set_loaded', true);
        })
        .catch(err => {
          err = handleError(err);
          context.commit('set_error', err);
          throw err;
        })
    }
  },
  mutations: {
    set_loaded (state, loaded) {
      state.loaded = loaded;
    },
    set_error (state, error) {
      state.error = error;
    },
    set_list (state, list) {
      state.list = list;
    },
  },
  getters: {
    loaded: state => state.loaded,
    error: state => state.error,
    list: state => state.list ? state.list : [],
  }
}